import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  disabled?: boolean;
  height?: number;
  onClick?: React.MouseEventHandler;
  width?: number;
};

export const Delete = React.memo((props: Props) => {
  const {
    width = 24,
    height = 24,
    className,
    disabled,
    color = disabled ? '#9f9da4' : '#0F0A1B',
    onClick,
  } = props;

  const style = {
    minWidth: width,
    minHeight: height,
  };

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={!disabled ? onClick : undefined}
      style={style}
      viewBox={`0 0 ${width} ${height}`}
    >
      <g fill='none'>
        <path d='M5.10427 10.5948C5.04835 10.0077 5.51002 9.5 6.09976 9.5H17.9002C18.49 9.5 18.9516 10.0077 18.8957 10.5948L18.0862 19.0948C18.0373 19.608 17.6063 20 17.0907 20H6.90929C6.39373 20 5.96267 19.608 5.91379 19.0948L5.10427 10.5948Z' stroke={color} strokeWidth='3' strokeLinecap='round' />

        <line
          x1='5.5'
          y1='5'
          x2='18.5'
          y2='5'
          stroke={color}
          strokeWidth='3'
          strokeLinecap='round'
        />

        <circle
          cx='12'
          cy='3.5'
          r='2'
          fill={color}
        />
      </g>

    </svg>
  );
});

Delete.displayName = 'Delete';
